import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalVars, GlobalConsts } from 'src/app/shared/global.vars';
import { StorageService } from './storage.service';
import { LogedInUserModel } from 'src/app/models';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AppAuthService {

  constructor(
    private router: Router,
    private globalVars: GlobalVars,
    private storageService: StorageService,
    private loginService: UserService
  ) {
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const paramsInUrl: number = Object.keys(next.params).length;
    let accessUrl;

    if (paramsInUrl > 0) {
      const url = state.url.split('/')[1];
      accessUrl = '/' + url;
    } else {
      accessUrl = state.url;
    }

    const oldUserProfile = await this.storageService.getValue(GlobalConsts.UserProfileLsKey);    

    if (oldUserProfile) {

      const userProfile = oldUserProfile as LogedInUserModel;     

      if (userProfile.UserToken !== '00000000-0000-0000-0000-000000000000') {

        this.globalVars.setUserProfile = userProfile;
        this.globalVars.setLoginStatus = true;
        this.globalVars.setIsPublicRole = userProfile.IsPublic;
        this.storageService.setValue(GlobalConsts.UserProfileLsKey, userProfile);

        return true;
      } else {

        this.globalVars.setLoginStatus = false;
        this.router.navigateByUrl('/welcome');
        return false;

      }

    } else {

      this.globalVars.setLoginStatus = false;
      this.router.navigateByUrl('/welcome');
      return false;

    }

  }

}
